export const hchart = [
  [
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "D",
    "D",
    "H",
    "S",
    "S",
    "S",
    "S",
    "S",
    "S",
    "S",
    "S",
    "BJ",
  ],
  [
    "H",
    "H",
    "H",
    "H",
    "H",
    "D",
    "D",
    "D",
    "H",
    "S",
    "S",
    "S",
    "S",
    "S",
    "S",
    "S",
    "S",
    "BJ",
  ],
  [
    "H",
    "H",
    "H",
    "H",
    "H",
    "D",
    "D",
    "D",
    "S",
    "S",
    "S",
    "S",
    "S",
    "S",
    "S",
    "S",
    "S",
    "BJ",
  ],
  [
    "H",
    "H",
    "H",
    "H",
    "H",
    "D",
    "D",
    "D",
    "S",
    "S",
    "S",
    "S",
    "S",
    "S",
    "S",
    "S",
    "S",
    "BJ",
  ],
  [
    "H",
    "H",
    "H",
    "H",
    "H",
    "D",
    "D",
    "D",
    "S",
    "S",
    "S",
    "S",
    "S",
    "S",
    "S",
    "S",
    "S",
    "BJ",
  ],
  [
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "D",
    "D",
    "H",
    "H",
    "H",
    "H",
    "H",
    "S",
    "S",
    "S",
    "S",
    "BJ",
  ],
  [
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "D",
    "D",
    "H",
    "H",
    "H",
    "H",
    "H",
    "S",
    "S",
    "S",
    "S",
    "BJ",
  ],
  [
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "D",
    "D",
    "H",
    "H",
    "H",
    "H",
    "H",
    "S",
    "S",
    "S",
    "S",
    "BJ",
  ],
  [
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "D",
    "H",
    "H",
    "H",
    "H",
    "H",
    "S",
    "S",
    "S",
    "S",
    "BJ",
  ],
  [
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "D",
    "H",
    "H",
    "H",
    "H",
    "H",
    "S",
    "S",
    "S",
    "S",
    "BJ",
  ],
];
